// extracted by mini-css-extract-plugin
export default {"container":"Header-module--container--2bM5L","dropdownContainer":"Header-module--dropdownContainer--2MFcg","menuIcon":"Header-module--menuIcon--1h5iC"};